import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AreasHeroSection from './components/AreasHeroSection';
import AreasGridSection from './components/AreasGridSection';

export default function AreasPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-16">
        <AreasHeroSection />
        <AreasGridSection />
      </main>
      <Footer />
    </div>
  );
}
